window.greyfinch = window.greyfinch || []
window.greyfinch.push({
  api: process.env.REACT_APP_API,
  app: process.env.REACT_APP_NAME,
  env: process.env.REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION,
})
